/*
 *   File : dashboard.js
 *   Author : https://evoqins.com
 *   Description : Home page
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";
import OneSignal from "react-onesignal";
import { useSelector } from "react-redux";



//custom component
import { SectionTitle } from "../../Component/Title";
import { FundCard, BasketCard, NFOCard, VideoCard } from "../../Component/Cards";
import { APIService } from "../../Service";
import { Calculator } from "../../Component/Calculator";
import { Footer } from "../../Component/Footer";
import { HowItWorksModal, IndexFundModal, UpdateKYCFATCADetailsModal, UpdateNomineeInfoModal, UploadCasQrCode, VerifyBankModal, WelcomeModal } from "../../Component/Modal";
import { _getProfile, _getSignupProgress, _goalDetailPath } from "../../Helper";
import { Icon } from "../../Component/Icon";
import { PrimaryButton } from "../../Component/Buttons";
import { _generateMFImportURL } from "../../Helper/api";

//assets
import Loader from "../../Assets/Images/coloured_loader.svg";
import OnboardingVideoModal from "../../Component/Modal/onboardingVideoModal";
import Banner1 from "../../Assets/Images/Home/banner/banner-1.webp";
import Banner2 from "../../Assets/Images/Home/banner/banner-2.webp";
import Banner3 from "../../Assets/Images/Home/banner/banner-3.webp";
import Banner4 from "../../Assets/Images/Home/banner/banner-4.webp";


// Colors
import Colors from "../../Style/color.scss";
// import { _generateMFImportURL } from "../../Helper/api";

const QUICK_ACTIONS = [
    {
        title: "Manage SIPs",
        icon: require("../../Assets/Images/Home/manage-sip.svg").default,
        action_url: "/sip",
        background: require("../../Assets/Images/Home/manage-sip-bg.png")
    },
    {
        title: "Family portfolio",
        icon: require("../../Assets/Images/Home/family-portfolio.svg").default,
        action_url: "/manage-family",
        background: require("../../Assets/Images/Home/family-portfolio-bg.png")
    },
    {
        title: "Download reports",
        icon: require("../../Assets/Images/Home/download-report.svg").default,
        action_url: "/reports",
        background: require("../../Assets/Images/Home/download-report-bg.png")
    },
];


const Dashboard = () => {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [homeData, setHomeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [showIndexFundModal, setShowIndexFundModal] = useState(false);
    const [showUploadMFQRModal, setShowUploadMFQRModal] = useState(false);
    const [howWorkModal, setHowWorkModal] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);
    const [showValues, setShowValues] = useState(localStorage.getItem(btoa("show_values")) ? localStorage.getItem(btoa("show_values")) === "true" : true);
    const [showExternal, setShowExternal] = useState(false);
    const [importLoader, setImportLoader] = useState(false);
    const [showBankProofAddModal, setShowBankProofAddModal] = useState(false);
    const [bankVerificationSuccess, setBankVerificationSuccess] = useState(false);

    const [showKycFATCAModal, setShowKycFATCAModal] = useState(false);
    const [showNomineeInfoModal, setShowNomineeInfoModal] = useState(false);

    // MF Import redirect handler
    useEffect(() => {
        const status = searchParams.get("status");
        const reqId = searchParams.get("reqId");

        if (status && reqId) {
            setShowUploadMFQRModal(true);
        }
    }, [searchParams]);

    useEffect(() => {

        let welcome_modal_status = localStorage.getItem("welcome-modal-enabled");

        if (welcome_modal_status === null) {
            setShowWelcomeModal(true);
        }

    }, [localStorage.getItem("welcome-modal-enabled")]);

    // Watch for USER_DATA and show FATCA update modal if not updated
    useEffect(() => {

        if (USER_DATA?.show_add_nominee_banner) {
            setShowNomineeInfoModal(true);
        } else if (USER_DATA && USER_DATA.fatca_updated === false) {
            setShowKycFATCAModal(true);
        }

    }, [USER_DATA]);

    useEffect(() => {

        let player_id = OneSignal.User.PushSubscription.id;

        setLoading(true);
        _getHomeDetails();

        if (player_id) {
            _saveOnesignalID();
        }


        window.scrollTo({
            top: 0, behavior: 'smooth'
        });

    }, []);



    useEffect(() => {

        if (showWelcomeModal) {
            let welcomeModal = new Modal(document.getElementById('welcomeModal'));
            welcomeModal.show();
            localStorage.setItem("welcome-modal-enabled", "true");  //set local storage
        }

    }, [showWelcomeModal]);

    useEffect(() => {

        if (showBankProofAddModal) {
            let bank_modal = new Modal(document.getElementById('verify-bank-modal'));
            bank_modal.show();
        }

    }, [showBankProofAddModal]);

    useEffect(() => {

        if (showIndexFundModal) {
            let index_fund = new Modal(document.getElementById('index-fund-modal'));
            index_fund.show();
        }

    }, [showIndexFundModal]);

    useEffect(() => {
        if (howWorkModal === true) {
            let works_modal = new Modal(document.getElementById('how-it-work-modal'));
            works_modal.show();
        }
    }, [howWorkModal]);

    useEffect(() => {
        if (showUploadMFQRModal === true) {
            let upload_mf_qrcode_modal = new Modal(document.getElementById('upload-mf-qr-code-modal'));
            upload_mf_qrcode_modal.show();
        }
    }, [showUploadMFQRModal]);

    useEffect(() => {
        if (showKycFATCAModal === true) {
            let kyc_fatca_modal = new Modal(document.getElementById('update-kyc-fatca'));
            kyc_fatca_modal.show();
        }
    }, [showKycFATCAModal]);

    useEffect(() => {
        if (showNomineeInfoModal) {
            new Modal(document.getElementById("update-nominee")).show();
        }
    }, [showNomineeInfoModal]);

    useEffect(() => {
        if (currentVideo !== null) {
            new Modal(document.querySelector("#onboarding-video")).show();
        }
    }, [currentVideo]);



    const _handleToggleShowValues = () => {
        setShowValues(prev => {
            localStorage.setItem(btoa("show_values"), !prev);
            return !prev
        });
    };

    // handle open how it work modal 
    // const _handleWorksModal = () => {
    //     setHowWorkModal(true);
    // };

    const _handleOnBasketClick = (basket_id) => {
        navigate("/baskets/basket-details", {
            state: {
                "basket_id": basket_id,
            }
        });
    };

    // handle close welcome modal
    const _handleCloseWelcomeModal = () => {
        setShowWelcomeModal(false);
    };

    // handle close import portfolio modal
    // const _hanUploadwIQRmportMFModal = () => {
    //     // setShowUploadMFQRModal(true);
    // };

    const _handleSuccessExternalImport = () => {
        navigate("portfolio");
        // Saving applied filters in localstorage
        localStorage.setItem("portfolio_filters", JSON.stringify({
            "selected_investment_type_filter": {
                id: 2,
                label: "Outside investment"
            }
        }));

    }

    const _handleOpenMFImport = () => {
        setImportLoader(true);
        // API call
        _generateMFImportURL().then((response) => {
            if (response?.status_code === 200) {
                let redirect_url = response?.data?.redirectUrl;
                window.open(redirect_url, "_self");
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setImportLoader(false);
        });
    };


    // handle close import portfolio modal
    // const _handleCloseImportPortfolioModal = () => {
    //     setShowUploadMFQRModal(false);
    // };

    const _handleToggleExternalInvest = () => {
        setShowExternal(!showExternal);
        setShowValues(true);
        localStorage.setItem(btoa("show_values"), true);
    };

    function _extractYouTubeId(url) {
        const patterns = [
            /youtube\.com\/.*[?&]v=([^&]+)/,      // watch?v=
            /youtu\.be\/([^?&]+)/,               // youtu.be/
            /youtube\.com\/embed\/([^?&]+)/,     // embed/
            /youtube\.com\/shorts\/([^?&]+)/     // shorts/
        ];

        for (const p of patterns) {
            const match = url.match(p);
            if (match) return match[1];
        }

        return null; // fallback
    };

    const _handleUploadBankDocument = () => {
        setShowBankProofAddModal(true);
    };

    const _handleBankProofAddSuccess = () => {
        setShowBankProofAddModal(false);
        setBankVerificationSuccess(true);
        // _getHomeDetails();
    };



    //API- Get home data 
    const _getHomeDetails = () => {
        let is_post = false;
        let url = 'home/get';
        let data = null;
        let token = null;

        APIService(is_post, url, data, token).then((response) => {
            if (response.status_code === 200) {
                setHomeData(response.data);
            } else {
                setHomeData([]);
            }
            setLoading(false);
        });
    };

    //  API - Send oneSignal ID
    const _saveOnesignalID = () => {

        // Player id
        let player_id = OneSignal.User.PushSubscription.id;

        let is_post = true;
        let url = 'notification/save-id';
        let data = {
            "player_id": player_id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                // console.log("One signal connected to DB");
            } else {
                // console.log("One signal connection failed");
            }
        });
    };


    return (
        <>

            <div className="row min-h-100vh e-bg-lotion p-4 e-border-radius-TL-BL-24px">
                {
                    loading === true ?
                        <div className="min-h-100vh text-center mt-5 pt-5" >
                            <img src={Loader}
                                draggable="false"
                                alt="loader" />
                        </div>
                        :
                        <div className="col-lg-12 pe-lg-5">
                            <div className="row flex-column flex-md-row">
                                <div className="col-12 col-md-8 mb-sm-5 order-2 order-md-1 e-padding-lr-res">
                                    {
                                        homeData.bank_verification_pending &&
                                        <div className="row ">
                                            <div className="col">
                                                <div className="p-1 e-border-radius-24 e-bg-egyptian-blue">
                                                    <div className="text-center e-bg-white e-border-radius-24 p-4">
                                                        <SectionTitle title={bankVerificationSuccess === false ? "We couldn’t verify your bank details" : "We’re verifying your details"}
                                                            className="e-font-20 e-text-eerie-black" />
                                                        <p className="mx-auto text-center mt-2 e-text-sonic-silver e-font-14 e-alt-font-poppins e-font-weight-500 line-height-20px mb-0">
                                                            {bankVerificationSuccess === false ? "Upload a document to complete your verification" : `We’re verifying your bank details, we’ll notify you ${<br className="d-none d-sm-block" />} once it’s done.`}
                                                        </p>
                                                        {
                                                            bankVerificationSuccess === false &&
                                                            <PrimaryButton name="Upload Document"
                                                                className={`col-9 col-sm-6 padding-12px-tb e-font-14 padding-8px-tb-res mt-4`}
                                                                onPress={_handleUploadBankDocument} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    }
                                    {
                                        homeData.nfo_list && homeData.nfo_list.length > 0 &&
                                        <>
                                            <SectionTitle title="Fresh opportunities (NFOs)" className="e-font-20 e-text-eerie-black mt-4" />
                                            <div className="row row-gap-4 mt-4 mb-4">
                                                {

                                                    homeData.nfo_list.map((item) => (
                                                        <div className="col-6 w-100-res" key={item.mf_id}>
                                                            <NFOCard data={item} handleClick={() => navigate("/explore/fund-details", { state: { fund_id: item.mf_id } })} />
                                                        </div>
                                                    ))

                                                }
                                            </div>
                                        </>
                                    }
                                    <div className="row pt-3 mb-4">
                                        <SectionTitle title="Curated investment basket" className="e-font-20 e-text-eerie-black" />
                                        <p className="mt-2 e-text-onyx e-font-14 e-alt-font-poppins e-font-weight-400 line-height-18px">
                                            With curated funds using CRISP insights
                                        </p>
                                        <div className="col-12">


                                            <div className="row row-cols-sm-3 row-gap-4">


                                                {
                                                    homeData.basket && homeData.basket.length > 0 ?
                                                        homeData.basket.map((data, key) => (
                                                            <div key={key} className="col-xl-4 col-lg-6 col-sm-6 col-6 w-100-res">
                                                                <BasketCard key={key}
                                                                    type={2}
                                                                    data={data}
                                                                    onClick={() => _handleOnBasketClick(data.basket_id)} />
                                                            </div>
                                                        ))
                                                        : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-sm-3 mb-4">

                                        <div className="col-12">
                                            <div id="home-banner" class="carousel slide carousel-fade" data-bs-ride="carousel">
                                                <div class="carousel-indicators">
                                                    <button type="button" data-bs-target="#home-banner" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                    <button type="button" data-bs-target="#home-banner" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                    {/* Total banners are 3 only when import banner also included */}
                                                    {
                                                        (homeData.show_external_portfolio_banner ||
                                                            homeData.external_portfolio_imported === false) &&
                                                        <button type="button" data-bs-target="#home-banner" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                    }
                                                    {
                                                        homeData.rebalance_available &&
                                                        <button type="button" data-bs-target="#home-banner" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                                    }
                                                </div>
                                                <div class="carousel-inner e-border-radius-32 e-border-radius-16-res">

                                                    {
                                                        homeData.rebalance_available &&
                                                        <div class="carousel-item active">
                                                            <img src={Banner4}
                                                                alt="icon"
                                                                className="img-fluid object-fit-contain home-banner-img cursor-pointer"
                                                                draggable={false}
                                                                onClick={() => navigate("/portfolio-rebalance", {
                                                                    state: { rebalance_run_id: homeData.rebalance_run_id }
                                                                })}
                                                            />
                                                        </div>
                                                    }

                                                    {
                                                        (homeData.show_external_portfolio_banner ||
                                                            homeData.external_portfolio_imported === false) &&
                                                        <div class={`${importLoader ? "cursor-wait" : "cursor-pointer"} ${homeData.rebalance_available ? "" : "active"} carousel-item`}>

                                                            <div class="card border-0" onClick={_handleOpenMFImport}>
                                                                <img src={Banner1}
                                                                    alt="icon"
                                                                    className="img-fluid object-fit-contain home-banner-img card-img"
                                                                    draggable={false} />
                                                                <div class="card-img-overlay h-100 p-0 d-flex align-items-center" id="re-import-banner">
                                                                    <div className="col-8 padding-32px-left">
                                                                        <h5 class="e-text-white e-primary-font-inter e-font-weight-600 line-height-32px mb-0 pb-2">
                                                                            {homeData.external_portfolio_imported ? "Imported fund data might be outdated" : "Import your existing investment"}
                                                                        </h5>
                                                                        <p class="e-text-pale-silver e-primary-font-inter e-font-weight-400 line-height-22px mb-0 pb-3 pb-lg-3 pb-xl-4">
                                                                            {homeData.external_portfolio_imported ? `Last update: ${homeData.external_portfolio_imported_on}` : "Import & manage your external portfolio in just 5 minutes."}
                                                                        </p>
                                                                        <span className="re-import-btn">
                                                                            {homeData.external_portfolio_imported ? "Re-Import now " : "Import now"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div class={`carousel-item ${homeData.external_portfolio_imported && homeData.show_external_portfolio_banner === false ? "active" : ""} `}>
                                                        <img src={Banner2}
                                                            alt="icon"
                                                            className="img-fluid object-fit-contain home-banner-img cursor-pointer"
                                                            draggable={false}
                                                            onClick={() => navigate("/manage-family")}
                                                        />
                                                    </div>
                                                    <div class="carousel-item">
                                                        <img src={Banner3}
                                                            alt="icon"
                                                            className="img-fluid object-fit-contain home-banner-img cursor-pointer"
                                                            draggable={false}
                                                            onClick={() => navigate("/explore")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-3 mb-4">
                                        <div className="col-12">
                                            <div className="e-bg-alice-blue_3 e-border-radius-16 p-3 p-sm-4 pb-sm-0 pb-0">
                                                <div className="d-flex gap-2 align-items-end align-items-sm-center justify-content-between">
                                                    <div>
                                                        <SectionTitle title="Index in focus" className="e-font-20 e-text-eerie-black" />
                                                        <p className="mt-sm-2 e-text-onyx e-font-12-res  e-font-14 e-alt-font-poppins e-font-weight-400 line-height-18px mb-0">
                                                            Curated funds to invest in
                                                        </p>
                                                    </div>
                                                    <span className={`e-font-12-res text-nowrap e-text-egyptian-blue e-primary-font-inter e-font-18 e-font-weight-500 e-primary-font-inter cursor-pointer text-decoration-hover-underline`}
                                                        onClick={() => navigate("/explore")}>
                                                        See all funds
                                                    </span>
                                                </div>
                                                <div className="row flex-nowrap overflow-x-scroll no-scrollbar pb-sm-4 pb-3 pt-3">
                                                    {
                                                        homeData.fund_list && homeData.fund_list.length > 0 ?
                                                            homeData.fund_list.map((item, key) => {
                                                                return (
                                                                    <div className="col-12 col-sm-7 col-md-8 col-lg-7 col-xl-6 w-100-res overflow-visible" key={key}>
                                                                        <FundCard type={4}
                                                                            data={item}
                                                                            handleOnClick={() => navigate("/explore/fund-details", { state: { fund_id: item.mf_id } })} />
                                                                    </div>
                                                                )
                                                            }) : ""
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="row pt-sm-3 mb-4 row-gap-4">
                                        <SectionTitle title="Hear from our dedicated Investors / Experts" className="e-font-20 e-text-eerie-black" />
                                        {
                                            homeData.videos.map((data, key) => (
                                                <div key={key} className="col-sm-6 col-12">
                                                    <VideoCard data={data} handleClickVideo={() => setCurrentVideo(data.video_url)} />
                                                </div>
                                            ))}
                                    </div>
                                    <div className="row pt-sm-3 mb-4">
                                        <div className="col-12">
                                            {/* SIP/Lumpsum Calculator */}
                                            <Calculator />
                                        </div>
                                    </div>
                                    <div className="row pt-1 mb-sm-5 mb-4">
                                        <div className="col-12">
                                            <p className="e-text-eerie-black-16per e-font-16-res e-font-18 e-primary-font-inter e-font-weight-700 line-height-24px mb-1">
                                                Trusted by over a million investors across India
                                            </p>

                                            <div className="e-bg-cultured d-inline-flex gap-sm-2 align-items-center gap-1 p-2 e-border-radius-16 mt-4">
                                                <span className="e-text-dark-jet e-font-12 e-alt-font-poppins e-font-weight-400 line-height-12px">
                                                    AMFI & SEBI registered firm
                                                </span>
                                                <Icon icon="arn-shild" size={"1rem"} />
                                                <span className="e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px">
                                                    ARN-272159
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                {/* Right Side */}
                                <div className="col-12 col-md-4 e-padding-lr-res pe-lg-4 mb-4 mb-sm-5 order-1 order-md-2">
                                    <div className="d-flex gap-4 gap-md-0 flex-column flex-sm-row flex-md-column  position-sticky top-0 mb-md-5">
                                        <div className="col-12 col-sm-6 col-md-12 flex-fill " >
                                            <div className="p-1 e-border-radius-24 e-bg-egyptian-blue">
                                                <div className="e-bg-white e-border-radius-24 p-3">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <h6 className="e-text-sonic-silver e-font-14 e-primary-font-inter e-font-weight-600 mb-3">
                                                            Your portfolio summary
                                                        </h6>
                                                        <span className="d-flex gap-1 align-items-center e-text-egyptian-blue e-font-10 e-primary-font-inter e-font-weight-400 e-border-1px-water-blue line-height-12px  e-border-radius-20 padding-6px-all e-bg-alice-blue_3 cursor-pointer"
                                                            onClick={_handleToggleExternalInvest}>
                                                            {showExternal ? "External" : "Internal"}
                                                            <Icon icon={"toggle-arrow"} size={12} className="cursor-pointer line-height-12px" />
                                                        </span>
                                                    </div>
                                                    {
                                                        showExternal === false ?
                                                            <>
                                                                <div className="e-border-bottom-1px-platinum-gray pb-3">
                                                                    <p className="e-text-eerie-black e-font-16 e-primary-font-inter e-font-weight-500 mb-1">
                                                                        Current investment
                                                                    </p>
                                                                    <span className={`${homeData.investment_data?.current_amount >= 0 ? "e-text-bottle-green" : "e-text-red"}  d-flex gap-2 align-items-center  e-primary-font-inter e-font-weight-700 e-font-28 line-height-36px`}>
                                                                        {showValues ? homeData.investment_data?.current_amount_text : homeData.investment_data?.masked_current_amount}
                                                                        <Icon icon={showValues ? "eye-open" : "eye-hide"} size={"1.25rem"} className="cursor-pointer" onClick={_handleToggleShowValues} />
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        Invested
                                                                    </p>
                                                                    <span className="e-text-eerie_black e-font-14 e-primary-font-inter e-font-weight-700 line-height-22px">
                                                                        {showValues ? homeData.investment_data?.invested_amount_text : homeData.investment_data?.masked_invested_amount}
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        Total Returns
                                                                    </p>
                                                                    <span className={`${homeData.investment_data?.returns_amount >= 0 ? "e-text-bottle-green" : "e-text-red"} d-flex align-items-center e-primary-font-inter  e-font-14 line-height-22px `}>
                                                                        <Icon icon="returns-arrow"
                                                                            size={"12px"}
                                                                            className={homeData.investment_data?.returns_amount >= 0 ? "" : "transform-rotate-180"}
                                                                            color={homeData.investment_data?.returns_amount >= 0 ? Colors.bottle_green : Colors.red} />
                                                                        <span className="ps-1 e-font-weight-700">{homeData.investment_data?.returns_amount >= 0 ? "+" : "-"} {showValues ? homeData.investment_data?.returns_amount_text : homeData.investment_data?.masked_returns_amount}</span>
                                                                        <span className="e-font-weight-500">({showValues ? homeData.investment_data?.returns_percentage_text : homeData.investment_data?.masked_returns_percentage})</span>
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        1D Returns
                                                                    </p>
                                                                    <span className={`${homeData.investment_data?.one_day_returns >= 0 ? "e-text-bottle-green" : "e-text-red"} d-flex align-items-center e-primary-font-inter  e-font-14 line-height-22px `}>
                                                                        <Icon icon={"returns-arrow"}
                                                                            size={"12px"}
                                                                            className={homeData.investment_data?.one_day_returns >= 0 ? "" : "transform-rotate-180"}
                                                                            color={homeData.investment_data?.one_day_returns >= 0 ? Colors.bottle_green : Colors.red} />
                                                                        <span className="ps-1 e-font-weight-700">{showValues ? homeData.investment_data?.one_day_returns_text : homeData.investment_data?.masked_one_day_returns}</span>
                                                                        <span className="e-font-weight-500">({showValues ? homeData.investment_data?.one_day_returns_percentage_text : homeData.investment_data?.masked_one_day_returns_percentage})</span>
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        XIRR
                                                                    </p>
                                                                    <span className="e-text-eerie_black e-font-14 e-primary-font-inter e-font-weight-700 line-height-22px">
                                                                        {showValues ? homeData.investment_data?.xirr_text : homeData.investment_data?.masked_xirr}
                                                                    </span>
                                                                </div>
                                                            </>
                                                            :
                                                            <>
                                                                <div className="e-border-bottom-1px-platinum-gray pb-3">
                                                                    <p className="e-text-eerie-black e-font-16 e-primary-font-inter e-font-weight-500 mb-1">
                                                                        Current investment
                                                                    </p>
                                                                    <span className={`${homeData.external_investment_data?.current_amount >= 0 ? "e-text-bottle-green" : "e-text-red"}  d-flex gap-2 align-items-center  e-primary-font-inter e-font-weight-700 e-font-28 line-height-36px`}>
                                                                        {showValues ? homeData.external_investment_data?.current_amount_text : homeData.external_investment_data?.masked_current_amount}
                                                                        <Icon icon={showValues ? "eye-open" : "eye-hide"} size={"1.25rem"} className="cursor-pointer" onClick={_handleToggleShowValues} />
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        Invested
                                                                    </p>
                                                                    <span className="e-text-eerie_black e-font-14 e-primary-font-inter e-font-weight-700 line-height-22px">
                                                                        {showValues ? homeData.external_investment_data?.invested_amount_text : homeData.external_investment_data?.masked_invested_amount}
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        Total Returns
                                                                    </p>
                                                                    <span className={`${homeData.external_investment_data?.returns_amount >= 0 ? "e-text-bottle-green" : "e-text-red"} d-flex align-items-center e-primary-font-inter  e-font-14 line-height-22px `}>
                                                                        <Icon icon="returns-arrow"
                                                                            size={"12px"}
                                                                            className={homeData.external_investment_data?.returns_amount >= 0 ? "" : "transform-rotate-180"}
                                                                            color={homeData.external_investment_data?.returns_amount >= 0 ? Colors.bottle_green : Colors.red} />
                                                                        <span className="ps-1 e-font-weight-700">{homeData.external_investment_data?.returns_amount >= 0 ? "+" : "-"} {showValues ? homeData.external_investment_data?.returns_amount_text : homeData.external_investment_data?.masked_returns_amount}</span>
                                                                        <span className="e-font-weight-500">({showValues ? homeData.external_investment_data?.returns_percentage_text : homeData.external_investment_data?.masked_returns_percentage})</span>
                                                                    </span>
                                                                </div>
                                                                <div className="mt-3">
                                                                    <p className="e-text-onyx e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-1">
                                                                        1D Returns
                                                                    </p>
                                                                    <span className={`${homeData.external_investment_data?.one_day_returns_amount >= 0 ? "e-text-bottle-green" : "e-text-red"} d-flex align-items-center e-primary-font-inter  e-font-14 line-height-22px `}>
                                                                        <Icon icon={"returns-arrow"}
                                                                            size={"12px"}
                                                                            className={homeData.external_investment_data?.one_day_returns_amount >= 0 ? "" : "transform-rotate-180"}
                                                                            color={homeData.external_investment_data?.one_day_returns_amount >= 0 ? Colors.bottle_green : Colors.red} />
                                                                        <span className="ps-1 e-font-weight-700">{showValues ? homeData.external_investment_data?.one_day_returns_text : homeData.external_investment_data?.masked_one_day_returns_amount}</span>
                                                                        <span className="e-font-weight-500">({showValues ? homeData.external_investment_data?.one_day_returns_percentage_text : homeData.external_investment_data?.masked_one_day_returns_percentage})</span>
                                                                    </span>
                                                                </div>
                                                            </>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-5 col-md-12 mt-md-4">
                                            <SectionTitle title="Quick action" className="e-font-20 e-text-eerie-black mb-3" />

                                            <div className="row flex-sm-column g-3">
                                                {
                                                    QUICK_ACTIONS.map((item, key) => (
                                                        <div className="col-6 col-sm-12 w-100-res">
                                                            <div key={key}
                                                                className="pt-3 ps-3 d-flex justify-content-between e-border-radius-20 overflow-hidden cursor-pointer card-hover"
                                                                style={{
                                                                    backgroundImage: `url(${item.background})`,
                                                                    backgroundSize: "cover",
                                                                    backgroundRepeat: 'no-repeat',
                                                                    backgroundPosition: 'center'
                                                                }}
                                                                onClick={() => navigate(item.action_url)} >
                                                                <p className="e-text-eerie-black e-font-18-res e-font-20 e-primary-font-inter e-font-weight-500 mb-0 col-4">
                                                                    {item.title}
                                                                </p>
                                                                <img src={item.icon} alt={item.title} className="pt-3" />
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div >

            {/* footer  component */}
            < Footer />

            {/* welcome modal  */}
            {
                showWelcomeModal &&
                <WelcomeModal onCloseModal={_handleCloseWelcomeModal} />
            }

            {/* learn how modal */}
            {
                showIndexFundModal &&
                <IndexFundModal onCloseModal={() => setShowIndexFundModal(false)} />
            }

            {/* how it works modal  */}
            {
                howWorkModal === true &&
                <HowItWorksModal onCloseModal={() => setHowWorkModal(false)} />
            }

            {
                showUploadMFQRModal &&
                // <ExternalFundImportModal onClose={_handleCloseImportPortfolioModal} />
                <UploadCasQrCode status={searchParams.get("status")}
                    handleSuccessImport={_handleSuccessExternalImport}
                    handleModalClose={() => setShowUploadMFQRModal(false)} />
            }

            {
                currentVideo !== null ?
                    <OnboardingVideoModal
                        // videoUrl={"https://www.youtube.com/embed/watch?v=JdXeK6YrQE8"}
                        data={_extractYouTubeId(currentVideo)}
                        onClose={() => setCurrentVideo(null)} />
                    :
                    null
            }

            {
                showBankProofAddModal &&
                <VerifyBankModal onSuccess={_handleBankProofAddSuccess} onClose={() => setShowBankProofAddModal(false)} />
            }
            {/* KYC FATCA update modal */}
            {
                showKycFATCAModal &&
                <UpdateKYCFATCADetailsModal onClose={() => setShowKycFATCAModal(false)} />
            }
            {
                showNomineeInfoModal &&
                <UpdateNomineeInfoModal onClose={() => setShowNomineeInfoModal(false)} />
            }

        </>
    )
}
export default Dashboard;